import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import WarehouseListTab from '../../modules/warehouse/WarehouseListTab';
import WarehouseStatusTab from '../../modules/warehouse/WarehouseStatusTab';
import WarehouseStatusOnDateTab from '../../modules/warehouse/WarehouseStatusOnDateTab';
import WarehouseTransactionTab from '../../modules/warehouse/WarehouseTransactionTab';



const Warehouse = (props) => {

    const [activeTab, setActiveTab] = useState('LIST');
    const [selectedRecord, setSelectedRecord] = useState();
    const [t] = useTranslation();

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const handleCallback = (id,action) => {
        switch(action){            
             case 'status':
                setSelectedRecord(id);
                setActiveTab('STATUS');                
             break;
             default:
        }
    };

    return (
        <>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>{t('warehouse.label.warehouse')}</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/">{t('warehouse.label.warehouses')}</Link>
                                </li>
                                <li className="breadcrumb-item active">
                                    {t('warehouse.label.warehouse')}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className="row"></div>
                            <div className="col-12 col-sm-12 col-lg-12" style={{margin: '0 auto',float: 'none'}}>
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" role="tablist">
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'LIST'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('LIST')
                                                    }
                                                >
                                                    {t('warehouse.label.list')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'STATUS'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('STATUS')
                                                    }
                                                >
                                                    {t('warehouse.label.status')}
                                                </button>
                                            </li>                                          
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'TRANSACTIONS'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('TRANSACTIONS')
                                                    }
                                                >
                                                    {t('warehouse.label.transactions')}
                                                </button>
                                            </li> 
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'STATUS_ON_DATE'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('STATUS_ON_DATE')
                                                    }
                                                >
                                                    {t('warehouse.label.statusOnDate')}
                                                </button>
                                            </li>               
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content">
                                            <WarehouseListTab
                                                isActive={activeTab === 'LIST'}
                                                parentCallback={handleCallback}    
                                            />                                                                                                                              
                                             <WarehouseStatusTab
                                                isActive={activeTab === 'STATUS'}
                                                selectedRecord={selectedRecord}
                                            />  
                                             <WarehouseTransactionTab
                                                isActive={activeTab === 'TRANSACTIONS'}
                                                selectedRecord={selectedRecord}
                                            />  
                                             <WarehouseStatusOnDateTab
                                                isActive={activeTab === 'STATUS_ON_DATE'}
                                                selectedRecord={selectedRecord}
                                            /> 
                                        </div>
                                    </div>
                                </div>   
                            </div>                         
                </div>
            </section>
        </>
    );
};

export default Warehouse;